document.addEventListener('DOMContentLoaded', () => {
  const videoObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(e => console.error('Video autoplay failed:', e));
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  function updateGallery(gallery, newIndex) {
    const container = gallery.querySelector('[data-gallery-container]');
    const items = gallery.querySelectorAll('[data-gallery-item]');
    const prevButton = gallery.querySelector('[data-gallery-prev-button]');
    const nextButton = gallery.querySelector('[data-gallery-next-button]');

    gallery.dataset.currentIndex = newIndex;
    const offset = newIndex * 100;
    container.style.transform = `translateX(${offset}%)`;

    if (prevButton && nextButton) {
        prevButton.disabled = newIndex === 0;
        nextButton.disabled = newIndex >= items.length - 1;
    }

    items.forEach((item, index) => {
      const video = item.querySelector('video');
      if (video) {
        if (index === newIndex) {
          videoObserver.observe(video);
        } else {
          videoObserver.unobserve(video);
          video.pause();
        }
      }
    });
  }

  function initGallery(gallery) {
    const items = gallery.querySelectorAll('[data-gallery-item]');
    if (items.length > 1) {
        gallery.querySelector('[data-gallery-next-button]').disabled = false;
    }
    updateGallery(gallery, 0);
  }

  // Event Delegation for gallery buttons
  document.addEventListener('click', event => {
    const prevButton = event.target.closest('[data-gallery-prev-button]');
    const nextButton = event.target.closest('[data-gallery-next-button]');

    if (prevButton) {
      const gallery = prevButton.closest('[data-product-gallery]');
      let currentIndex = parseInt(gallery.dataset.currentIndex || '0', 10);
      if (currentIndex > 0) {
        updateGallery(gallery, currentIndex - 1);
      }
    }

    if (nextButton) {
      const gallery = nextButton.closest('[data-product-gallery]');
      const items = gallery.querySelectorAll('[data-gallery-item]');
      let currentIndex = parseInt(gallery.dataset.currentIndex || '0', 10);
      if (currentIndex < items.length - 1) {
        updateGallery(gallery, currentIndex + 1);
      }
    }
  });

  // Initial setup for galleries present on page load
  document.querySelectorAll('[data-product-gallery]').forEach(initGallery);

  // MutationObserver to detect and initialize new galleries
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Check if it's an element node
          // If the added node is a gallery itself
          if (node.matches('[data-product-gallery]')) {
            initGallery(node);
          }
          // Check for galleries within the added node
          node.querySelectorAll('[data-product-gallery]').forEach(initGallery);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
